// components/Loader.jsx
import React from "react";

const Loader = () => (
  <div className="flex justify-center items-center h-screen">
    <div className="main-loader"></div>
  </div>
);

export default Loader;
